import { setupClients } from '@internetworkexpert/js-common'

const env = process.env.NODE_ENV || 'production'
const {
  API,
  BUSINESS,
  CONTENT,
  EXERCISES,
  FILES,
  IFRAME,
  PROFILE,
  QUIZ,
  STATISTICS,
  SUBSCRIPTIONS,
  UAA,
  VIDEOS,
  MIXPANEL,
  CERTIFICATIONS,
  CONTENT_BACKOFFICE,
  VIDEO_BACKOFFICE,
} = setupClients(env)

export {
  API,
  BUSINESS,
  CONTENT,
  EXERCISES,
  FILES,
  IFRAME,
  PROFILE,
  QUIZ,
  STATISTICS,
  SUBSCRIPTIONS,
  UAA,
  VIDEOS,
  MIXPANEL,
  CERTIFICATIONS,
  CONTENT_BACKOFFICE,
  VIDEO_BACKOFFICE,
}